import React from 'react';
import EstatosDetailComponent from '../Estatos/estatos_details';
import Lang from '../../lang';
import PedidosAjudaFormDetails from './PedidosAjudaFormDetails';
const InputFieldsAll = {
  "Descrição": [
    {
      key: 'estatuto',
      type: 'text',
      display: 'Descrição'
    }
  ],
  "Detal": [
    // {
    //     key : "codEstatuto",
    //     type : "dropdown",
    //     display : Lang.langCheck.langRequest("Cod Estatuto")
    // },
    {
      key: 'moduloContaCorrente',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Corrente')
    },
    {
      key: 'moduloFiscalizacao',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Fiscalização')
    },
    {
      key: 'moduloVindima',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Vindima')
    },
    {
      key: 'moduloParcela',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Parcela')
    },
    {
      key: 'moduloConvocatoria',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Convocatória')
    },
    {
      key: 'moduloInstalacoesVinicas',
      type: 'checkbox',
      display: Lang.langCheck.langRequest('Instalações Vínicas')
    },
  ]
};

class DetailsPedidoAjuda extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <PedidosAjudaFormDetails topBarMenuOption={topBarMenu} id={this.props} InputFieldsAll={InputFieldsAll} />
    );
  }
}

export default DetailsPedidoAjuda;
